import React, { useEffect, useState } from "react";
import "./ModalDivulgarApp.css";
import GooglePlayButton from "../Buttons/GooglePlay";
import AppleStoreButton from "../Buttons/AppleStore";

export default function ModalDivulgarApp() {
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const jaViu = localStorage.getItem("propagandaAppVisto");

    if (!jaViu) {
      // Abre o modal
      setShowModal(true);

      // Salva no localStorage
      localStorage.setItem("propagandaAppVisto", "true");
    }
  }, []);

  if (!showModal) return null;

  return (
    <div className="app-modal-overlay">
      <div className="app-modal">

        {/* BOTÃO FECHAR */}
        <button className="modal-close" onClick={() => setShowModal(false)}>
          ✕
        </button>

        {/* IMAGEM */}
        <img
          src="https://via.placeholder.com/320x350.png?text=Imagem+do+APP"
          alt="App UEB"
          className="modal-img"
        />

        {/* TEXTO */}
        <h2>Baixe o App da UEB</h2>
        <p>
          Acesse carteirinhas, informações e muito mais diretamente no seu celular.
        </p>

        {/* BOTÕES */}
        <div className="modal-buttons">
          <GooglePlayButton />
          <AppleStoreButton />
        </div>
      </div>
    </div>
  );
}
